<loading *ngIf="loading" class="full">
  Loading your info
</loading>

<ng-container *ngIf="!loading && agreements">
  <ul class="agreements">
    <li *ngFor="let agreement of agreements">
      {{agreement.title}}. <a *ngIf="agreement.link" [href]="agreement.link" target="_blank">read More</a>
    </li>
  </ul>
  <button class="btn btn-primary" (click)="onSubmit()">Agree & Continue</button>
</ng-container>

<ng-content *ngIf="!loading && !agreements"></ng-content>